import React from 'react'
import banner from '../../images/newfork-removebg-preview.png'
import { styled } from '../../stitches/stitches.config'
import FadeInImage from '../base/FadeInImage'

const FadeInOutBanner: React.FC = () => {
  const [fadeIn, setFadeIn] = React.useState(true)
  const handleFadeInCompleted = () => {
    setFadeIn(false)
  }

  return fadeIn ? (
    <Container>
      <ImageWrapper>
        <FadeInImage src={banner} onFadeInCompleted={handleFadeInCompleted} />
      </ImageWrapper>
    </Container>
  ) : null
}

export default FadeInOutBanner

const Container = styled('div', {
  zIndex: '$global1',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
  width: '100%',
  flex: 1,
  overflow: 'hidden',
  background: '$background',

  '&:empty': {
    display: 'none',
  },
})

const ImageWrapper = styled('div', {
  width: '70%',
  maxWidth: '200px',

  '&:empty': {
    display: 'none',
  },
})
